export default function TS_Editor() {
  return (
    <div>
      <h1>TS Editor</h1>
      <p>This is the TS Editor page.</p>
    </div>
  );
}